import { useContext } from "react";
import { AppContext } from "../../../app/AppContext.tsx";

export const useConfig = () => {
  const { config } = useContext(AppContext);
  if (!config) throw new Error("Config not initialized");
  return config;
};
